import * as i0 from "@angular/core";
export class IndexOfPipeModule {
}
IndexOfPipeModule.ɵfac = function IndexOfPipeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IndexOfPipeModule)(); };
IndexOfPipeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IndexOfPipeModule });
IndexOfPipeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
